import React, { useContext, useEffect, useRef } from 'react';
import SmartVideoObserverContext from '../../context/SmartVideoObserverContext';

import './SmartVideo.css';

/**
 * @param altSrc: source of alt image used before lazy-loading video
 */
interface SmartVideoProps {
  alt: string;
  altSrc: string;
  src: string;
}

// Video that autoPlays and loops when fully visible
const SmartVideo: React.FC<SmartVideoProps> = ({ alt, altSrc, src }) => {
  const observerContext = useContext(SmartVideoObserverContext);
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (videoRef?.current == null) {
      return;
    }

    const videoRefCopy = videoRef.current;
    observerContext.observe(videoRefCopy);
    return () => {
      observerContext.unobserve(videoRefCopy);
    };
  }, [observerContext]);

  return (
    <div className="smart-video">
      <img className="video-alt" src={altSrc} alt={alt} />
      <video data-src={src} ref={videoRef} loop playsInline></video>
    </div>
  );
};

export default SmartVideo;
